import styled, { css } from "styled-components";

const DeleteConfirmationModalStyled = styled.div`
   position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal {
  background: white;
  padding: 32px;
  border-radius: 10px;
  border: 2px solid #D22630;
  width: 530px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  z-index: 1001;
   }
   
`

export { DeleteConfirmationModalStyled };